import { Button } from '@shared/components/ui/button'
import { Loader2 } from 'lucide-react'
import { ActivationStatusBadge } from './ActivationStatusBadge'
import { DeactivateProfessionalDialog } from './DeactivateProfessionalDialog'

interface ProfessionalProfileActivationSectionProps {
  isEditing: boolean
  isActive: boolean
  isActivating: boolean
  isSubmitting: boolean
  onActivate: () => void
  onDeactivate: () => void
}

export function ProfessionalProfileActivationSection({
  isEditing,
  isActive,
  isActivating,
  isSubmitting,
  onActivate,
  onDeactivate,
}: ProfessionalProfileActivationSectionProps) {
  if (!isEditing && isEditing !== false) return null

  return (
    <div className="flex flex-col items-center justify-between p-2 bg-gray-50 rounded-lg">
      <div className="flex gap-2 items-center">
        <span className="text-sm font-medium">Estado de activación</span>
        <ActivationStatusBadge isActive={isActive} />
      </div>

      {!isActive && (
        <div className="w-full pt-4">
          <Button
            type="button"
            variant="secondary"
            onClick={onActivate}
            disabled={isActivating || isSubmitting}
            className="flex-1 w-full"
          >
            {isActivating && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
            {isActivating ? 'Activando...' : 'Activar cuenta profesional'}
          </Button>
        </div>
      )}

      {isActive && isEditing && (
        <div className="w-full pt-4">
          <DeactivateProfessionalDialog
            onConfirm={() => Promise.resolve(onDeactivate())}
            disabled={isSubmitting}
          />
        </div>
      )}
    </div>
  )
}
